// eslint-disable-next-line
import mustache from 'mustache/mustache.mjs'
import { ModeSettingsHelper } from '../settings'
import { getStringPropFromObjectOrNull } from '../../utils/stringUtils'

export const BANK_TRANSFER_SETTINGS_MODES = {
  DISABLED: 'DISABLED',
}

export class BankTransferSettingsHelper extends ModeSettingsHelper {
  _ordine

  constructor(settings, ordine) {
    super(settings)

    this._ordine = ordine
    this.addIdsToSchemas(this._settings)
  }

  get cardStyle() {
    return (this._settings && this._settings.card_style) || null
  }

  get descriptionRendered() {
    const description = getStringPropFromObjectOrNull(
      this._settings,
      'description'
    )
    if (!description) {
      return null
    }

    return mustache.render(description, {
      sellout: {
        bonifico_settings: this._settings,
        ordine: this._ordine,
      },
    })
  }

  get isBankTransferDisabled() {
    return (
      this._settings &&
      this._settings.mode &&
      BANK_TRANSFER_SETTINGS_MODES.DISABLED ===
        this._settings.mode.toUpperCase()
    )
  }
}
